import { render, staticRenderFns } from "./regdespesa.vue?vue&type=template&id=5c00d70b"
import script from "./regdespesa.vue?vue&type=script&lang=js"
export * from "./regdespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports